import {Alignment} from '@wonderlandengine/api';
import {
    Align,
    Display,
    Justify,
    PositionType,
    ReactUiBase,
} from '@wonderlandengine/react-ui';
import {
    Button,
    Column,
    Container,
    MaterialContext,
    Panel,
    Row,
    Text,
} from '@wonderlandengine/react-ui/components';

import React from 'react';
import {Modal} from './custom-components.js';

export const ConfirmationDialog = (props: {
    onConfirm: () => void;
    onCancel: () => void;
    text: string;
}) => {
    const {onConfirm, onCancel} = props;

    return (
        <Modal
            onCancel={onCancel}
            width={'50%'}
            maxHeight={'50%'}
            resolution={30}
            rounding={30}
            alignContent={Align.Center}
            backgroundColor={0xccccccff}
        >
            <Column
                gap={5}
                alignContent={Align.Center}
                justifyContent={Justify.Center}
                margin={20}
            >
                <Text fontSize={30} color={0x000000ff} textAlign="center">
                    Confirm Purchase
                </Text>
                <Text fontSize={20} color={0x000000ff} textAlign="center">
                    {props.text}
                </Text>
                <Row
                    width="100%"
                    alignContent={Align.Center}
                    justifyContent={Justify.SpaceAround}
                    gap={20}
                    paddingTop={50}
                >
                    <Button
                        key="cancel"
                        hovered={{backgroundColor: 0x6b3531ff}}
                        active={{backgroundColor: 0x8f4742ff}}
                        backgroundColor={0xb85b54ff}
                        width="40%"
                        alignContent={Align.Center}
                        justifyContent={Justify.Center}
                        onClick={onCancel}
                        padding={10}
                        rounding={10}
                    >
                        <Text fontSize={25} color={0xffffffff} textAlign="center">
                            Cancel
                        </Text>
                    </Button>
                    <Button
                        key="confirm"
                        hovered={{backgroundColor: 0x449049ff}}
                        active={{backgroundColor: 0x005433ff}}
                        backgroundColor={0x005433ff}
                        width="40%"
                        alignContent={Align.Center}
                        justifyContent={Justify.Center}
                        onClick={onConfirm}
                        padding={10}
                        rounding={10}
                    >
                        <Text fontSize={25} color={0xffffffff} textAlign="center">
                            Yes!
                        </Text>
                    </Button>
                </Row>
            </Column>
        </Modal>
    );
};
